import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router"

export const Route = createFileRoute("/_authenticated/$slug/monthly-reports")({
  staticData: { title: "Monthly Report" },
  component: lazyRouteComponent(
    () => import("#pages/authenticated/monthly-reports/page.tsx"),
    "MonthlyReports",
  ),
})
